module.exports = __webpack_public_path__ + "img/4.72fc65b0.png";